<template>
  <div>
    <div class="mb-4">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3> -->
        <h3 class="fsize30 text-primary font-semibold mb-4" v-if="!cardView">
          {{ this.serviceName }}
        </h3>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Request for Service</span>
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <p>
        <span class="font-bold text-primary"> Service Description:</span> A
        "Care Assistance Service" typically refers to a range of supportive
        services aimed at assisting individuals who may require help due to age,
        illness, disability, or other circumstances. The goal is to provide
        care, support, and assistance to improve the quality of life for those
        in need.
      </p>
      <br />

      <div class="text-777777 font-normal mb-2">
        <span class="font-bold text-primary">
          Why Consider Care Assistant:
        </span>
        <ul class="list-decimal">
          <li>Enhances quality of life by providing necessary support.</li>
          <li>Enables individuals to live independently at home.</li>
          <li>
            Provides peace of mind to family members knowing their loved ones
            are well-cared for.
          </li>
          <li>Promotes social engagement and overall well-being.</li>
        </ul>
      </div>
      <!-- <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal ml-8">
          <span class="font-bold text-primary"> Guidance and Support: </span>
          Receive one-on-one coaching tailored to your caregiving needs,
          providing valuable guidance and support.
        </li>

        <li class="text-777777 font-normal ml-8">
          <span class="font-bold text-primary"> Building Resilience: </span>
          Learn strategies to build resilience, enabling you to navigate
          caregiver stress with greater ease.
        </li>

        <li class="text-777777 font-normal ml-8">
          <span class="font-bold text-primary"> Emotional Mastery: </span>
          Develop emotional mastery to cope with compassion fatigue and process
          complex emotions effectively.
        </li>
      </ul> -->

      <p>
        <span class="text-primary font-bold"> Our Service:</span> We have
        partnered with reputed and trusted care service providers to fulfill
        your need for a care assistant or nurses at home pan-India. Each care
        assistance service provider may have specific offerings or variations
        based on their expertise, but the core aim remains to provide holistic
        care and support to enhance the lives of those who require assistance.
        <br />
      </p>
      <!-- <p class="mt-4">
        <span class="font-bold text-primary mt-2">For Whom:</span> Family
        caregivers seeking guidance and emotional support.
      </p> -->
      <h6 class="mt-3 text-primary fsize16 font-bold">Why Choose Us:</h6>
      <ul class="list-decimal">
        <li>
          At Caregiver Saathi we understand the importance of finding reliable,
          compassionate care for yourself or your loved ones.
        </li>
        <li>
          We believe in individualized care that meets unique needs. Our
          dedicated team conducts thorough assessments and assign a care
          assistant accordingly.
        </li>
        <li>
          Our caregivers are not just professionals; they are compassionate
          individuals committed to delivering the highest standard of care.
        </li>
        <li>
          Your preferences matter. We involve you in decision-making, respect
          your autonomy, and actively listen to your needs, ensuring a
          client-centered approach to care.
        </li>
      </ul>
      <p></p>
      <!-- <p class="mb-2">
        Tailored coaching for your unique caregiving challenges
      </p>
      <p class="mb-2">Build resilience and emotional mastery.</p>
      <p class="mb-2">Navigate caregiver stress with confidence.</p>

      <p class="mb-2">Process complex emotions effectively</p>

      <p class="mb-2 underline">Empower Your Caregiving Journey Today!</p>

      <p class="mb-2">
        Price:<span class="text-primary">
          Affordable coaching sessions starting at INr 4000/ session + 18%
          GST.</span
        >
      </p>
      <p class="mb-2 text-primary">
        For 5 or more sessions:<span class="text-primary">
          INR 3500/ session + 18% GST</span
        >
      </p> -->
    </div>
    <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";

export default {
  // props: ["location"],
  components: {
    Bcard,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("auth", ["user"]),
  },
  methods: {
    async handleService() {
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
      } catch (error) {
        console.log(error);
      }

      // this.$router.push({ name: "map-inside", query: { service: true } });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
    },
    handleRoute(name, params) {
      // if (Object.keys(this.user).length === 0) {
      //   this.$swal.fire({
      //     title: "",
      //     text: "Please login to access this content",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   this.$router.push({ name: "signin" });
      //   return;
      // }
      this.$router.push({ name: name, params: { pathName: params } });
    },
  },
  mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
    this.serviceName = this.$route.query.service;
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
